import { getEventBusIfDefined } from '@cian/event-bus';

import get from 'lodash/get';
import * as React from 'react';

import { ISpecialPromoLinkData } from '../../../app/models/promo';

import { ITopMenuLinks, TopMenu } from '../../components/TopMenu';
import { IHeaderV1Schema } from '../../repositories/header/entities/response/HeaderV1Schema';
import { IDropdownMenuContainerProps } from '../DropdownMenuContainer';
import { TDealRentLinkExperiment } from '../../types/experiments';
import { getMenuLinks } from './utils/getMenuLinks';

export interface ITopMenuContainerProps {
  dropdownMenusData: { [key: string]: IDropdownMenuContainerProps };
  specialPromoLinkData: ISpecialPromoLinkData;
  headerData: IHeaderV1Schema;
  activeKey?: string;
  regionId: number;
  isCianProEnabled: boolean;
  dealRentLinkExperiment: TDealRentLinkExperiment;
}

export interface ITopMenuContainerState {
  activeKey?: string;
}

export class TopMenuContainer extends React.Component<ITopMenuContainerProps, ITopMenuContainerState> {
  public constructor(props: ITopMenuContainerProps) {
    super(props);

    this.state = {
      activeKey: props.activeKey,
    };
  }

  public componentDidMount() {
    const eventBus = getEventBusIfDefined();

    if (eventBus) {
      eventBus.subscribe('header:category_changed', this.categoryChangedHandler);
    }
  }

  public render() {
    const { dropdownMenusData, specialPromoLinkData, regionId } = this.props;
    const { activeKey } = this.state;

    return (
      <TopMenu
        dropdownMenusData={dropdownMenusData}
        specialPromoLinkData={specialPromoLinkData}
        menuLinks={this.makeMenuLinks()}
        catalogDevelopersUrl={this.getCatalogDevelopersUrl()}
        catalogRealtorsUrl={this.getCatalogRealtorsUrl()}
        otherLinks={this.getOtherLinks()}
        activeKey={activeKey}
        regionId={regionId}
      />
    );
  }

  private categoryChangedHandler = (event: CianEventBus.IEvent) => {
    const { type } = event;

    this.setState({ activeKey: type });
  };

  private makeMenuLinks = (): ITopMenuLinks[] => {
    const { headerData, isCianProEnabled, dealRentLinkExperiment } = this.props;

    return getMenuLinks({ isCianProEnabled, dealRentLinkExperiment }).map(menuLink => {
      const { name, title, trackingLabel, path, section } = menuLink;
      const link = menuLink.link || (path && get(headerData, path));

      return {
        name,
        title,
        trackingLabel,
        link,
        section,
      };
    });
  };

  private getCatalogDevelopersUrl = () => {
    const { headerData } = this.props;

    if (headerData && headerData.catalogDevelopers) {
      return headerData.catalogDevelopers;
    }

    return '';
  };

  private getCatalogRealtorsUrl = () => {
    const { headerData } = this.props;

    if (headerData?.catalogRealtors) {
      return headerData.catalogRealtors;
    }

    return '';
  };

  private getOtherLinks = () => {
    const { headerData } = this.props;

    if (headerData && headerData.otherLinks) {
      return headerData.otherLinks;
    }

    return undefined;
  };
}
